import { AxiosPromise } from "axios";
import { UserUpdateRoleRequest } from "./types";
import { UserUpdateRoleResponse } from "./types";
import { axiosInstance } from "../instance";

export const userUpdateRole = (
  params: UserUpdateRoleRequest,
): AxiosPromise<UserUpdateRoleResponse> =>
  axiosInstance.post(`/user/${params.param.id}/update-role`, params.data);